import React from "react";
import { useMediaQuery } from "react-responsive";

function ViewStarReview({ PD_ID, reviewValue }) {
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const starShapes = {
    1: [{ g: "translate(15,15) scale(0.6)", polygons: ["translate(0,0)"] }],
    2: [
      {
        g: "translate(15,15) scale(0.5)",
        polygons: ["translate(-7,-7)", "translate(7,7)"],
      },
    ],
    3: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: ["translate(0,-10)", "translate(-10,7)", "translate(10,7)"],
      },
    ],
    4: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: [
          "translate(-10,-10)",
          "translate(10,-10)",
          "translate(10,10)",
          "translate(-10,10)",
        ],
      },
    ],
    5: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: [
          "translate(0,-14)",
          "translate(-14,-3)",
          "translate(14,-3)",
          "translate(8,13)",
          "translate(-8,13)",
        ],
      },
    ],
  };

  const getFillPercentage = (star) => {
    if (reviewValue >= star) return 100;
    if (reviewValue + 1 > star) return (reviewValue % 1) * 100;
    return 0;
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "6px",
        scale: isMobile ? "0.8" : "1",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const fillPercent = getFillPercentage(star);
        const gradientId = `grad-${PD_ID}-${star}`;

        // ✅ Set colors based on fill level
        const circleStroke = fillPercent > 0 ? "#cc4e00" : "#cc4e00";
        const polygonFill = fillPercent > 0 ? "#cc4e00" : "white"; // white when 0
        const polygonStroke = fillPercent > 0 ? "#cc4e00" : "#cc4e00"; // black border when 0

        return (
          <svg
            key={star}
            width="30"
            height="30"
            viewBox="0 0 30 30"
            style={{ overflow: "visible" }}
          >
            <defs>
              <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset={`${fillPercent}%`} stopColor="#fc9700" />
                <stop offset={`${fillPercent}%`} stopColor="white" />
              </linearGradient>
            </defs>

            {/* Circle background */}
            <circle
              cx="15"
              cy="15"
              r="13"
              stroke={circleStroke}
              strokeWidth="2"
              fill={fillPercent > 0 ? `url(#${gradientId})` : "white"}
            />

            {/* Star shapes */}
            {starShapes[star].map((group, gi) => (
              <g key={gi} transform={group.g}>
                {group.polygons.map((transform, pi) => (
                  <polygon
                    key={pi}
                    points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
                    fill={polygonFill}
                    stroke={polygonStroke}
                    strokeWidth="1.5"
                    transform={transform}
                  />
                ))}
              </g>
            ))}
          </svg>
        );
      })}
    </div>
  );
}

export default ViewStarReview;
